import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { PrivacyPolicySimpleQuote } from '@/screens/Legal/PrivacyPolicySimpleQuote';

export default function PrivacyPolicySimpleQuotePage() {
  return (
    <>
      <Head>
        <meta name="keywords" content="loadsmart privacy policy" />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Simple Quote Privacy Policy"
        description="Loadsmart Simple Quote Privacy Policy"
        canonical="https://loadsmart.com/simple-quote/"
        openGraph={{
          url: 'https://loadsmart.com/simple-quote/',
        }}
      />
      <PrivacyPolicySimpleQuote />
    </>
  );
}
